var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _vm.isLoading
        ? _c(
            "v-layout",
            { staticStyle: { "padding-top": "150px" } },
            [_c("PageLoader", { attrs: { resourceName: "Configurations" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c("Index", {
            attrs: {
              configurations: _vm.configurations,
              form: _vm.dynamicFormComponent,
            },
            on: {
              fetchConfigurations: function ($event) {
                return _vm.fetchConfigurations(_vm.service)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c("CreateDialog", {
            on: {
              fetchConfigurations: function ($event) {
                return _vm.fetchConfigurations(_vm.service)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }